import Axios from "axios";
import Vue from "vue";

const SUCCESS_STATUS = ['0'];
const UPDATE_TYPE = {
  IMAGE: '图片',
  FILE: '文件'
}
const POST_TYPE = {
  POST: 'POST',
  GET: 'GET'
}

/**
 * 图片上传
 * @param url <String>
 * @param formData 必传
 * @param map
 * @param headers
 * @returns {Promise<AxiosResponse<any>>}
 */
const uploadImageDefaultForMap = (formData,map=(obj)=>obj.data, headers) => uploadImage(undefined, formData, headers,map)
const uploadImageDefault = (formData, headers) => uploadImage(undefined, formData, headers)
const uploadImage = (url, formData = {}, headers,map) => Axios.post(url || '/file/uploadImage', formData, getUploadConfig(headers))
  .then(res => getUploadResponseData(res, UPDATE_TYPE.IMAGE, POST_TYPE.POST,map))
/**
 * 文件上传
 * @param formData
 * @param headers
 * @param map
 * @param headers
 * @returns {Promise<*>}
 */
const uploadFileDefaultForMap = (formData,map=(obj)=>obj.data, headers) => uploadFile(undefined, formData, headers,map)
const uploadFileDefault = (formData, headers) => uploadFile(undefined, formData, headers)
const uploadFile = (url, formData = {}, headers,map) => Axios.post(url || '/fileUpload/uploadFile', formData, getUploadConfig(headers))
  .then(res => getUploadResponseData(res, UPDATE_TYPE.FILE, POST_TYPE.POST,map))
/**
 *
 * @param formData
 * @param headers
 * @returns {Promise<*>}
 */
const teacherNotesUpload = (formData = {}, headers) => uploadFile('/file/teacherNotes/upload', formData,headers)
const teacherNotesUploadForMap = (formData = {}, headers,map=(obj)=>obj.data) => uploadFile('/file/teacherNotes/upload', formData,headers,map)

/**
 * 文件下载
 * @param url
 * @returns {Promise<*>}
 */
const downloadFile = (url,headers) => Axios.get(url, getDownloadConfig(headers))
  .then(res => getDownloadResponseData(res, UPDATE_TYPE.FILE, POST_TYPE.GET))
const downloadFileForPost = (url, formData = {},headers) => Axios.post(url, formData, getDownloadConfig(headers))
  .then(res => getDownloadResponseData(res, UPDATE_TYPE.FILE, POST_TYPE.GET))

/**
 * 下载配置
 * @param headers
 */
function getDownloadConfig(headers = {}) {
  if (!(headers instanceof Object))headers = {};
  return {
    headers: JSON.parse(JSON.stringify({...getHeaders(), ...headers})),
    responseType: 'blob',
  }
}

/**
 * 上传配置
 * @param headers
 */

function getUploadConfig(headers = {}) {
  return {
    headers: JSON.parse(JSON.stringify({...getHeaders(), ...headers})),
    baseURL: process.env.UPLOAD_NAME
  }
}

/**
 * 默认headers
 */
function getHeaders() {
  return {
    [process.env.AUTHORIZATION]: 'bearer ' + localStorage.getItem('Authorization'),
    'Content-Type': 'multipart/form-data'
  }
}

/**
 * 上传回调
 * @param res
 * @param msg
 * @param type
 */
function getUploadResponseData(res, msg, type,map) {
  if (!res.data || !SUCCESS_STATUS.includes(String(res.data.code)) || res.status !== 200) {
    console.log(`${msg}上传失败`, res)
    Vue.prototype.$messageError((res.data && res.data.msg) || `${msg}上传失败`)
    return Promise.reject(res)
  }
  console.log(`${msg}上传成功`, res)
  return Promise.resolve((typeof map === 'function') ? map(res.data) : res.data)
}

/**
 * 下载回调
 * @param res
 * @param msg
 * @param type
 */
function getDownloadResponseData(res, msg, type) {
  if (res.status !== 200) {
    console.log(`${msg}下载失败`, res)
    Vue.prototype.$messageError((res.data && res.data.msg) || `${msg}下载失败`)
    return Promise.reject(res)
  }
  console.log(`${msg}下载成功`, res)
  return Promise.resolve(res.data)
}

/**
 * 点击下载
 * @param remoteUrl 下载地址 必输
 * @param rename 重命名 非必输
 * @param formData 参数 非必输
 * @param headers 参数 非必输
 */
function clickDownloadForPost(remoteUrl,rename,formData,headers){
  downloadFileForPost(remoteUrl,formData || {},headers).then(data=>download(data,rename))
}
function clickDownload(remoteUrl,rename,headers){
  downloadFile(remoteUrl,headers).then(data=>download(data,rename))
}
function download(data,rename){
  const url = URL.createObjectURL(data)
  const a = document.createElement('a')
  a.href = url
  if (typeof rename === 'string'){
    a.download = rename
  }
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}
export {
  uploadImage,
  uploadImageDefault,
  uploadImageDefaultForMap,
  uploadFile,
  uploadFileDefault,
  uploadFileDefaultForMap,
  downloadFile,
  teacherNotesUpload,
  teacherNotesUploadForMap,
  clickDownload,
  clickDownloadForPost,
}



// WEBPACK FOOTER //
// ./src/api/filePostApi.js